import { Note as TonalNote, Midi } from "tonal";
import { Range, rangeToMidi } from "./ranges";

export type MidiNote = number;

export type GroupedNotes = [MidiNote | undefined, MidiNote | undefined];

export enum Note {
  // "a0" = "a0",
  // "a#0" = "a#0",
  // "b0" = "b0",
  // "c1" = "c1",
  // "c#1" = "c#1",
  // "d1" = "d1",
  // "d#1" = "d#1",
  // "e1" = "e1",
  // "f1" = "f1",
  // "f#1" = "f#1",
  // "g1" = "g1",
  // "g#1" = "g#1",
  // "a1" = "a1",
  // "a#1" = "a#1",
  // "b1" = "b1",
  "c2" = "c2",
  "c#2" = "c#2",
  "d2" = "d2",
  "d#2" = "d#2",
  "e2" = "e2",
  "f2" = "f2",
  "f#2" = "f#2",
  "g2" = "g2",
  "g#2" = "g#2",
  "a2" = "a2",
  "a#2" = "a#2",
  "b2" = "b2",
  "c3" = "c3",
  "c#3" = "c#3",
  "d3" = "d3",
  "d#3" = "d#3",
  "e3" = "e3",
  "f3" = "f3",
  "f#3" = "f#3",
  "g3" = "g3",
  "g#3" = "g#3",
  "a3" = "a3",
  "a#3" = "a#3",
  "b3" = "b3",
  "c4" = "c4",
  "c#4" = "c#4",
  "d4" = "d4",
  "d#4" = "d#4",
  "e4" = "e4",
  "f4" = "f4",
  "f#4" = "f#4",
  "g4" = "g4",
  "g#4" = "g#4",
  "a4" = "a4",
  "a#4" = "a#4",
  "b4" = "b4",
  "c5" = "c5",
  "c#5" = "c#5",
  "d5" = "d5",
  "d#5" = "d#5",
  "e5" = "e5",
  "f5" = "f5",
  "f#5" = "f#5",
  "g5" = "g5",
  "g#5" = "g#5",
  "a5" = "a5",
  "a#5" = "a#5",
  "b5" = "b5",
  "c6" = "c6",
  "c#6" = "c#6",
  "d6" = "d6",
  "d#6" = "d#6",
  "e6" = "e6",
  "f6" = "f6",
  // "f#6" = "f#6",
  // "g6" = "g6",
  // "g#6" = "g#6",
  // "a6" = "a6",
  // "a#6" = "a#6",
  // "b6" = "b6",
  // "c7" = "c7",
  // "c#7" = "c#7",
  // "d7" = "d7",
  // "d#7" = "d#7",
  // "e7" = "e7",
  // "f7" = "f7",
  // "f#7" = "f#7",
  // "g7" = "g7",
  // "g#7" = "g#7",
  // "a7" = "a7",
  // "a#7" = "a#7",
  // "b7" = "b7",
  // "c8" = "c8",
}

const midiToNoteMap: Map<number, Note> = new Map([
  // [21, Note["a0"]],
  // [22, Note["a#0"]],
  // [23, Note["b0"]],
  // [24, Note["c1"]],
  // [25, Note["c#1"]],
  // [26, Note["d1"]],
  // [27, Note["d#1"]],
  // [28, Note["e1"]],
  // [29, Note["f1"]],
  // [30, Note["f#1"]],
  // [31, Note["g1"]],
  // [32, Note["g#1"]],
  // [33, Note["a1"]],
  // [34, Note["a#1"]],
  // [35, Note["b1"]],
  [36, Note["c2"]],
  [37, Note["c#2"]],
  [38, Note["d2"]],
  [39, Note["d#2"]],
  [40, Note["e2"]],
  [41, Note["f2"]],
  [42, Note["f#2"]],
  [43, Note["g2"]],
  [44, Note["g#2"]],
  [45, Note["a2"]],
  [46, Note["a#2"]],
  [47, Note["b2"]],
  [48, Note["c3"]],
  [49, Note["c#3"]],
  [50, Note["d3"]],
  [51, Note["d#3"]],
  [52, Note["e3"]],
  [53, Note["f3"]],
  [54, Note["f#3"]],
  [55, Note["g3"]],
  [56, Note["g#3"]],
  [57, Note["a3"]],
  [58, Note["a#3"]],
  [59, Note["b3"]],
  [60, Note["c4"]],
  [61, Note["c#4"]],
  [62, Note["d4"]],
  [63, Note["d#4"]],
  [64, Note["e4"]],
  [65, Note["f4"]],
  [66, Note["f#4"]],
  [67, Note["g4"]],
  [68, Note["g#4"]],
  [69, Note["a4"]],
  [70, Note["a#4"]],
  [71, Note["b4"]],
  [72, Note["c5"]],
  [73, Note["c#5"]],
  [74, Note["d5"]],
  [75, Note["d#5"]],
  [76, Note["e5"]],
  [77, Note["f5"]],
  [78, Note["f#5"]],
  [79, Note["g5"]],
  [80, Note["g#5"]],
  [81, Note["a5"]],
  [82, Note["a#5"]],
  [83, Note["b5"]],
  [84, Note["c6"]],
  [85, Note["c#6"]],
  [86, Note["d6"]],
  [87, Note["d#6"]],
  [88, Note["e6"]],
  [89, Note["f6"]],
  // [90, Note["f#6"]],
  // [91, Note["g6"]],
  // [92, Note["g#6"]],
  // [93, Note["a6"]],
  // [94, Note["a#6"]],
  // [95, Note["b6"]],
  // [96, Note["c7"]],
  // [97, Note["c#7"]],
  // [98, Note["d7"]],
  // [99, Note["d#7"]],
  // [100, Note["e7"]],
  // [101, Note["f7"]],
  // [102, Note["f#7"]],
  // [103, Note["g7"]],
  // [104, Note["g#7"]],
  // [105, Note["a7"]],
  // [106, Note["a#7"]],
  // [107, Note["b7"]],
  // [108, Note["c8"]],
]);

const noteToMidiMap: Map<Note, MidiNote> = new Map(
  Array.from(midiToNoteMap.entries()).map((x) => x.reverse()) as [
    Note,
    number
  ][]
);

export function midiToNote(midi: MidiNote): Note {
  const note = midiToNoteMap.get(midi);

  if (!note) {
    throw new Error(`Note not found for midi ${midi}`);
  }

  return note;
}

export function noteToMidi(note: Note): MidiNote {
  const midi = noteToMidiMap.get(note);

  if (!midi) {
    throw new Error(`Midi not found for note ${note}`);
  }

  return midi;
}

export const midiNotes = Array.from(midiToNoteMap.keys());

export function isNoteBefore(note: MidiNote, otherNote: MidiNote) {
  return note < otherNote;
}

export function groupBasesMidiNoteWithSharps(
  orderedMidiNotes: MidiNote[]
): GroupedNotes[] {
  const groupedSharpsWithRegularNotes: [
    MidiNote | undefined,
    MidiNote | undefined
  ][] = [];

  for (let i = 0; i < orderedMidiNotes.length; i++) {
    const note = orderedMidiNotes[i]; // Midi.midiToNoteName(orderedMidiNotes[i], { sharps: true });

    // if first key is black key then add array with undefined as first type
    if (i === 0 && isBlackKey(note)) {
      groupedSharpsWithRegularNotes.push([undefined, note]);
    } else if (isBlackKey(note)) {
      const lastGroupedNote =
        groupedSharpsWithRegularNotes[groupedSharpsWithRegularNotes.length - 1];

      lastGroupedNote[1] = note;
    } else {
      groupedSharpsWithRegularNotes.push([note, undefined]);
    }
  }

  return groupedSharpsWithRegularNotes;
}

export function isBlackKey(midi: MidiNote) {
  return Midi.midiToNoteName(midi, { sharps: true }).includes("#");
}

export function tonalNoteToMidi(tonalNote: string): MidiNote {
  const note = TonalNote.midi(tonalNote);

  if (!note) {
    throw new Error(`Midi not found for note ${tonalNote}`);
  }

  return note;
}

export function midiToTonalNote(midi: MidiNote): string {
  const note = TonalNote.fromMidiSharps(midi);

  if (!note) {
    throw new Error(`Note not found for midi ${midi}`);
  }

  return note;
}

export function getLetterOnlyFromNote(note: Note): string {
  return note.replace(/[^a-zA-Z]/g, "").toLowerCase();
}

export function getOctaveFromNote(note: Note): number {
  return parseInt(note.replace(/[^0-9]/g, ""), 10);
}

export function isNote(note: string): note is Note {
  if (typeof note !== "string") {
    return false;
  }

  return Object.keys(Note).includes(note);
}
